import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

import {
  SidebarContainer,
  SidebarGroup,
  SidebarHeader,
  SidebarIcon,
  SidebarItem,
  SidebarLink,
  SidebarMenu,
  SidebarText,
  SidebarTitle,
} from "../Sidebar/Sidebar.styles";
import SidebarUserFooter from "../Sidebar/SidebarUserFooter";
import {
  calendarIcon,
  catalogIcon,
  courseImg,
  helpIcon,
  settingsIcon,
} from "assets/icons";
import { useAuth } from "../../context/AuthContext";
import { useUser } from "../../context/UserContext";
import { fetchStudentSupport } from "../../services/studentPortalService/studentPortalService";

const StudentSidebarItem: React.FC<{
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
  text: string;
  to: string;
}> = ({ icon, text, to }) => {
  const location = useLocation();
  const isActive = location.pathname === to || location.pathname.startsWith(`${to}/`);
  return (
    <SidebarItem>
      <Link to={to}>
        <SidebarLink isActive={isActive}>
          <SidebarIcon as={icon} aria-hidden="true" />
          <SidebarText>{text}</SidebarText>
        </SidebarLink>
      </Link>
    </SidebarItem>
  );
};

const StudentSidebar: React.FC = () => {
  const { logout } = useAuth();
  const { user } = useUser();
  const [supportUrl, setSupportUrl] = useState<string | null>(null);
  const name = [user?.firstName, user?.lastName].filter(Boolean).join(" ") || "Ученик";

  useEffect(() => {
    let active = true;
    fetchStudentSupport()
      .then(({ support_url }) => {
        if (active) setSupportUrl(support_url);
      })
      .catch(() => {
        if (active) setSupportUrl(null);
      });
    return () => {
      active = false;
    };
  }, []);

  return (
    <SidebarContainer>
      <SidebarHeader>LISRENT</SidebarHeader>
      <SidebarMenu>
        <SidebarGroup>
          <SidebarTitle>Обучение</SidebarTitle>
          <StudentSidebarItem icon={courseImg} text="Мои курсы" to="/student/courses" />
          <StudentSidebarItem icon={catalogIcon} text="Каталог курсов" to="/student/catalog" />
          <StudentSidebarItem icon={calendarIcon} text="Календарь" to="/student/calendar" />
          <StudentSidebarItem icon={settingsIcon} text="Настройки" to="/student/settings" />
        </SidebarGroup>
      </SidebarMenu>

      <SidebarUserFooter
        name={name}
        email={user?.email || ""}
        isLoading={!user}
        menuActions={
          supportUrl
            ? [
                {
                  label: "Поддержка",
                  icon: helpIcon,
                  onSelect: () => window.open(supportUrl, "_blank", "noopener,noreferrer"),
                },
              ]
            : []
        }
        onLogout={logout}
        logoutTo="/login?role=student"
      />
    </SidebarContainer>
  );
};

export default StudentSidebar;
